import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  CollectionType,
  EchartsTitleMap,
  StatsChartType,
} from '@pages/statistics-page/constants';
import { StatsChartConfiguration } from '@pages/statistics-page/interfaces';
import { StatisticsDataService } from '@pages/statistics-page/services/statistics-data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mileage',
  templateUrl: './mileage.component.html',
  styleUrls: ['./mileage.component.scss'],
  providers: [
    StatisticsDataService,
    { provide: 'chartGroupType', useValue: CollectionType.Mileage },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MileageComponent implements OnInit {
  private dataService = inject(StatisticsDataService);

  mileageChartData$: Subject<Map<StatsChartType, StatsChartConfiguration>>;

  chartType: typeof StatsChartType = StatsChartType;
  chartTitle: typeof EchartsTitleMap = EchartsTitleMap;

  ngOnInit(): void {
    this.mileageChartData$ = this.dataService.chartData$;
  }
}
